module.exports = __webpack_public_path__ + "img/img (19).321c8d56.jpg";